<!-- www.quickepay / Business
Edited with WebStorm
Created by maizerg on 2/20/18 at 6:39 PM
<!-->

<template>
<router-view></router-view>



</template>

<script>
/*export default {}*/
import QuickSiteBreadCrumb from '../../components/site/SiteBreadCrumb'

export default {components: {QuickSiteBreadCrumb}}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/business/Business.vue